import { type FC } from 'react'
import { type BookingClient } from '../../../models/Scheduling'
import { noClientHasEmail } from './clientEmailGaps'

export const ClientEmailNotice: FC<{ clients: BookingClient[] }> = ({ clients }) => {
  if (!noClientHasEmail(clients)) {
    return null
  }
  return (
    <div
      role='status'
      aria-live='polite'
      className='d-flex align-items-center zocks-gap-0.5 zocks-px-0.75 py-2 mt-2 rounded-3 zocks-border-color-warning zocks-bg-color-white'
    >
      <i className='bi bi-exclamation-triangle-fill zocks-text-warning-dark flex-shrink-0' aria-hidden='true' />
      <div className='paragraph-small zocks-text-gray-900'>
        <span className='bold'>Guests don&apos;t have email addresses.</span>
        <br />
        Add a client or email address to send the invite.
      </div>
    </div>
  )
}
